import { Category } from 'interfaces/Category';
import { RepositoryParams, api } from '..';

export type CategoryFilters = Partial<Category & RepositoryParams>;

export const list = async (params: CategoryFilters) => {
  return api.get('/categorias', { params });
};

export const listAll = async (params: CategoryFilters) => {
  return api.get('/categorias/all', { params });
};

export const listPinned = async (
  budgetTemplateId: string,
  costCenterId: string
) => {
  return api.get('/categorias/pinned', {
    params: { budgetTemplateId, costCenterId },
  });
};

export const create = async (params: Category) => {
  return api.post('/categorias', { ...params });
};

export const update = async (params: Category) => {
  return api.patch(`/categorias/${params.id}`, { ...params });
};

export const retrieve = async (id: string) => {
  return api.get(`/categorias/${id}`);
};

export const remove = async (id: string) => {
  return api.delete(`/categorias/${id}`);
};
